export const COVER_HEIGHT_VH = '64vh';
export const COVER_HEIGHT = 64;
export const BUTTONS_HEIGHT = 6;
export const NAV_HEIGHT = 46;
